document.addEventListener("DOMContentLoaded", () => {
  const burger = document.querySelector(".bs-header__burger");
  const drawer = document.querySelector(".bs-header__drawer");
  const body = document.body;
  const header = document.querySelector(".bs-header");

  if (burger && drawer) {
    burger.addEventListener("click", () => {
      const isOpen = drawer.classList.toggle("open");
      burger.classList.toggle("open", isOpen);
      drawer.hidden = !isOpen;
      body.style.overflow = isOpen ? "hidden" : "";
    });
  }

  let lastScroll = window.scrollY;
  let ticking = false;

  window.addEventListener("scroll", () => {
    if (!header) return;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScroll = window.scrollY;
        const delta = currentScroll - lastScroll;

        if (currentScroll > 80) {
          header.classList.add("sticky-active");
        } else {
          header.classList.remove("sticky-active");
        }

        if (delta > 40 && currentScroll > 80) {
          header.classList.add("hidden");
        }

        if (delta < -40) {
          header.classList.remove("hidden");
        }

        lastScroll = currentScroll;
        ticking = false;
      });

      ticking = true;
    }
  });
});
